import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-toastify'

import en from 'src/constants/en'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { AiChatApi } from 'src/services/aiChatApi'

import { UseDeleteAiChatConversationMutationParams } from './interfaces/useDeleteAiChatConversationMutation.interface'

export const useDeleteAiChatConversationMutation = ({
  onError,
  onSuccess,
}: UseDeleteAiChatConversationMutationParams = {}) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (conversationId: string) =>
      AiChatApi.deleteConversation(conversationId),
    onError: () => {
      toast.error(en.AI_CHAT_DELETE_CONVERSATION_ERROR)
      onError?.()
    },
    onSuccess: (_data, conversationId) => {
      queryClient.invalidateQueries({
        queryKey: [QueryKey.GET_AI_CHAT_CONVERSATIONS],
      })
      queryClient.removeQueries({
        queryKey: [QueryKey.GET_AI_CHAT_CONVERSATION, conversationId],
      })
      toast.success(en.AI_CHAT_DELETE_CONVERSATION_SUCCESS)
      onSuccess?.(conversationId)
    },
  })
}
